import { MEDIA_TYPES } from "@pathwright/ui/src/components/filestack/constants"
import TextArea from "@pathwright/ui/src/components/form/form-textarea/TextArea"
import { useTranslate } from "@pathwright/ui/src/components/lng/withTranslate"
import PropTypes from "prop-types"
import React from "react"
import { Field, Form, validators } from "react-connect-form-forked"
import { SubmitEditWrapper, SubmitInnerUI } from "../ui"
import { handleSubmitFileTypeChange } from "../utils"
import ChooseFileType from "./ChooseFileType"

const PROMPT_MAX_LENGTH = 128

const SubmitEdit = ({ data, onChange }) => {
  const [prompt, setPrompt] = React.useState(data.submitPrompt || null)
  const [allowedType, setAllowedType] = React.useState(
    data.allowedType || MEDIA_TYPES.IMAGE
  )

  const { t } = useTranslate()

  const formRef = React.useRef()

  React.useEffect(() => {
    if (data.submitPrompt !== prompt) setPrompt(data.submitPrompt)
    if (data.allowedType !== allowedType) setAllowedType(data.allowedType)
  }, [data.submitPrompt, data.allowedType])

  const handleChangeInstruction = ({ prompt }) => {
    const submitPrompt = prompt || ""

    if (submitPrompt.length > PROMPT_MAX_LENGTH) {
      // required to fire validation ui
      return formRef.current.blurField("prompt")
    }

    if (submitPrompt === data.submitPrompt) return

    onChange({ submitPrompt })
  }

  const handleChangeFileType = ({ value, label }) => {
    const change = handleSubmitFileTypeChange(value, data.submission)
    setAllowedType(value)

    onChange(change)
  }

  return (
    <SubmitEditWrapper className="SubmitEdit">
      <SubmitInnerUI>
        <ChooseFileType
          onChangeFileType={handleChangeFileType}
          currentFileType={allowedType}
        />
        <div
          className="SubmitEdit__prompt"
          style={{ width: "80%", margin: "0 auto", maxWidth: "600px" }}
        >
          <Form
            onChange={handleChangeInstruction}
            initialValue={{ prompt }}
            ref={formRef}
          >
            <Field
              name="prompt"
              render={(props) => <TextArea {...props} defaultValue={prompt} />}
              type="text"
              validators={[validators.isMaxLength(PROMPT_MAX_LENGTH)]}
              placeholder={t("blocks.submit.add_custom_message")}
            ></Field>
          </Form>
        </div>
      </SubmitInnerUI>
    </SubmitEditWrapper>
  )
}

SubmitEdit.propTypes = {
  onChange: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  layout: PropTypes.string.isRequired
}

export default SubmitEdit
